import { amplitudeEvent } from 'lib/amplitude'

export const BOOKING_TYPE_EVENTS = {
  CREATED: 'booking-type-created',
}

export const trackBookingTypeCreated = ({ salesModel, category }) => {
  amplitudeEvent(BOOKING_TYPE_EVENTS.CREATED, {
    sales_model: salesModel,
    category,
  })
}
